import axios from "../axios"

const list = (params = null) => {
    return axios.get('/admin/refs/expert-type', { params: params })
        .then(response => response.data);
}

const block = (id) => {
    return axios
        .post(`/admin/refs/expert-type/block/${id}`)
        .then(response => response.data);
};

const unblock = (id) => {
    return axios
        .post(`/admin/refs/expert-type/unblock/${id}`)
        .then(response => response.data);
};

const store = (form) => {
    return axios
        .post(`/admin/refs/expert-type/new`, form)
        .then(response => response.data)
}

const update = (id, form) => {
    return axios
        .post(`/admin/refs/expert-type/${id}/edit`, form)
        .then(response => response.data)
}

const detail = (id) => {
    return axios
        .get(`/admin/refs/expert-type/${id}`)
        .then(response => response.data)
}

export default {
    list,
    block,
    unblock,
    store,
    update,
    detail,
}
